import React, { useState } from "react";
import { API_BASE } from "../../config/api";
import "./Login.css";

// Login global du portail — même mécanisme que l'assistant/dashboard (POST /api/auth/login).
// Au 1er login, l'utilisateur est créé côté serveur. La session est stockée dans localStorage
// (clé nexamed_portal_user). Aucun mot de passe n'est conservé côté client.
const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const r = await fetch(`${API_BASE}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim().toLowerCase(), password: pw }),
      });
      const j = await r.json();
      if (r.ok && j.ok) {
        const user = { email: j.email, name: j.name, role: j.role };
        try { localStorage.setItem("nexamed_portal_user", JSON.stringify(user)); } catch (_) {}
        onLogin(user);
      } else {
        setErr(j.error || "Échec de connexion");
      }
    } catch (_) {
      setErr("Erreur réseau — réessayez");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="login-logo">🏥</div>
        <h1 className="login-title">Portail Dossiers</h1>
        <p className="login-sub">CHU de Treichville — Oncologie pédiatrique</p>
        <label className="login-field">
          <span>Email</span>
          <input type="email" value={email} autoFocus required
                 placeholder="prenom.nom@chu.ci"
                 onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label className="login-field">
          <span>Mot de passe</span>
          <input type="password" value={pw} required
                 placeholder="••••••••"
                 onChange={(e) => setPw(e.target.value)} />
        </label>
        {err && <div className="login-err">{err}</div>}
        <button className="login-btn" type="submit" disabled={busy || !email || !pw}>
          {busy ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
};

export default Login;
